// src/lib/analytics.ts
declare global {
  interface Window {
    dataLayer?: Record<string, any>[];
  }
}

export function pushDL(event: string, params: Record<string, any> = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}
